import FeatureEditorContainer from './FeatureEditorContainer'

export default FeatureEditorContainer
